import React from 'react';

function ConditionsGenerales() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          width: '60px',
          height: '80px',
          border: '2px solid #2E234A',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          padding: '8px',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#2E234A',
        }}
      >
        <div
          style={{
            width: '80%',
            height: '8px',
            backgroundColor: '#2E234A',
            marginBottom: '6px',
          }}
        ></div>
        <div
          style={{
            width: '80%',
            height: '6px',
            backgroundColor: '#2E234A',
            marginBottom: '6px',
          }}
        ></div>
        <div
          style={{
            width: '100%',
            height: '4px',
            backgroundColor: '#2E234A',
            marginBottom: '2px',
          }}
        ></div>
        <div
          style={{
            width: '60%',
            height: '4px',
            backgroundColor: '#2E234A',
            marginBottom: '2px',
          }}
        ></div>
        <div style={{ width: '90%', height: '4px', backgroundColor: '#2E234A' }}></div>
      </div>
      <a
        href="/conditions-generales"
        style={{
          marginTop: '10px',
          color: '#2E234A',
          textDecoration: 'none',
          fontSize: '14px',
          textAlign: 'center',
        }}
      >
        Voir les Conditions Générales d'Utilisation (EU)
      </a>
    </div>
  );
}

export default ConditionsGenerales;
